import { cn } from "~/lib/utils";

interface StatsLineProps {
  children: React.ReactNode;
  className?: string;
  "aria-label"?: string;
}

export function StatsLine({ children, className, ...props }: StatsLineProps) {
  return (
    <span
      className={cn(
        "inline-flex flex-wrap items-center gap-y-0.5 text-sm",
        "[&>span:not(:first-child)]:before:content-['·'] [&>span:not(:first-child)]:before:mx-1",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
